import { Injectable } from '@angular/core';

import { Observable, ReplaySubject } from 'rxjs';

import { FuseNavigationItem } from '@fuse/components/navigation';

import { environment } from 'environments/environment';
import { appNavigation } from 'app/app.navigation';
import { Navigation } from 'app/core/navigation/navigation.types';

import { AuthService } from '../auth/auth.service';
import { Role } from '../auth/auth.types';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);
  private userRoles: Role[] = [];

  private isNavigationItemHidden = (item: FuseNavigationItem) =>
    item.meta?.roles && (environment.production || !this.userRoles?.includes(Role.SuperAdmin))
      ? !this.userRoles?.some((role) => item.meta.roles.includes(role))
      : false;

  constructor(private authService: AuthService) {
    this.authService.userRoles$.subscribe((roles) => (this.userRoles = roles));
  }

  get navigation$(): Observable<Navigation> {
    return this.navigation.asObservable();
  }

  initialize(): void {
    this.navigation.next({ default: this.transformNavigationItems(appNavigation.default) } as Navigation);
  }

  private transformNavigationItems(items: FuseNavigationItem[]): FuseNavigationItem[] {
    return items.map((item) => {
      if (item.meta?.roles) {
        item.hidden = this.isNavigationItemHidden;
      }

      if (item.children) {
        item.children = this.transformNavigationItems(item.children);
      }

      return item;
    });
  }
}
